
const $ = require('./main.js');

$(document).ready(function ($) {

  if ($.support.pjax) {
    $.pjax.defaults.timeout = 30000;

    var $activeFormLi = null;
    $(document).on('click', '.js-certified-tab', function (event) {
      event.preventDefault();
      $('.js-certified-tab').removeClass('active');
      var containerSelector = '.js-certified-section';
      var url = $(this).data('href');
      $.pjax.reload(containerSelector, {
        url: url,
        fragment: containerSelector
      });
      $(this).addClass('active');
    });
    $('.js-certified-section').on('pjax:complete', function () {

    });
  }

  $(document).on('click','.js-heading', function (){
    $(this).next().toggleClass('visuallyhidden');
    if ($(this).next().hasClass('visuallyhidden')) {
      $(this).find('button').attr('aria-expanded', false);
    } else {
      $(this).find('button').attr('aria-expanded', true);
    }
  });

   /* const headings = document.querySelectorAll('.js-heading');

    Array.prototype.forEach.call(headings, h => {
      let btn = h.querySelector('button');
      let target = h.nextElementSibling;

      btn.onclick = () => {
        let expanded = btn.getAttribute('aria-expanded') === 'true';

        btn.setAttribute('aria-expanded', !expanded);
        target.hidden = expanded;
      }
    });*/

});


